var AdvDecResponseMappper = /** @class */ (function () {
    function AdvDecResponseMappper() {
    }
    AdvDecResponseMappper.prototype.formatResponse = function (streamRes, cb) {
        try {
            var ResData = JSON.parse(streamRes).response.data;
            if (ResData) {
                cb({
                    low: ResData.dc,
                    high: ResData.ac,
                    target: ResData.zc,
                    symbol: ResData.sym,
                    lut: ResData.ltt,
                });
            }
        }
        catch (error) { }
    };
    return AdvDecResponseMappper;
}());
export default AdvDecResponseMappper;
